<template>
    <div class="crm-invoices">
        <b-card class="invoices-card">
            <b-table
                :items="invoices"
                :fields="tableFields"
                responsive
                hover
                class="invoices-table"
                tbody-tr-class="invoice-row"
            >
                <template #cell(id)="data">
                    <span class="invoice-id">{{ data.item.id }}</span>
                </template>
                <template #cell(date)="data">
                    <span class="invoice-date">{{ data.item.date }}</span>
                </template>
                <template #cell(amount)="data">
                    <span class="invoice-amount">${{ formatAmount(data.item.amount) }}</span>
                </template>
                <template #cell(status)="data">
                    <b-badge pill class="badge-paid">{{ data.item.status }}</b-badge>
                </template>
                <template #cell(action)="data">
                    <div class="action-cell">
                        <b-button variant="link" class="link-view p-0" @click="viewInvoice(data.item)">
                            View Details
                        </b-button>
                        <b-button variant="link" class="btn-download p-0 ml-2" @click="downloadInvoice(data.item)">
                            <i class="fa fa-download"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "CrmInvoices",
    props: {
        accountId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            tableFields: [
                { key: "id", label: "INVOICE ID", thClass: "table-header" },
                { key: "date", label: "DATE", thClass: "table-header" },
                { key: "amount", label: "AMOUNT", thClass: "table-header" },
                { key: "status", label: "STATUS", thClass: "table-header" },
                { key: "action", label: "ACTION", thClass: "table-header action-col" },
            ],
            invoices: [
                { id: "INV-2026-001", date: "2026-02-01", amount: 1200, status: "Paid" },
                { id: "INV-2026-002", date: "2026-01-01", amount: 1200, status: "Paid" },
                { id: "INV-2025-012", date: "2025-12-01", amount: 1150, status: "Paid" },
            ],
        };
    },
    methods: {
        formatAmount(amount) {
            if (amount >= 1000) {
                return `${Math.floor(amount / 1000)},${String(amount % 1000).padStart(3, "0")}`;
            }
            return String(amount);
        },
        viewInvoice(invoice) {
            console.log("viewInvoice", invoice);
        },
        downloadInvoice(invoice) {
            console.log("downloadInvoice", invoice);
        },
    },
};
</script>

<style scoped>
.crm-invoices {
    padding: 0;
}

.invoices-card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: 24px;
}

.invoices-card >>> .card-body {
    padding: 0;
}

.invoices-table >>> thead th {
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    color: #6c757d;
    text-transform: uppercase;
    border-bottom: 1px solid #e9ecef;
    padding: 14px 16px;
}

.invoices-table >>> thead th.action-col {
    text-align: right;
}

.invoices-table >>> tbody td {
    padding: 16px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f3f5;
}

.invoices-table >>> tbody tr.invoice-row:hover {
    background-color: #f8f9fa;
}

.invoices-table >>> tbody tr:last-child td {
    border-bottom: 0;
}

.invoice-id {
    font-weight: 700;
    color: #1a1d21;
}

.invoice-date {
    color: #495057;
}

.invoice-amount {
    font-weight: 700;
    color: #1a1d21;
}

.badge-paid {
    background-color: #d4edda !important;
    color: #155724 !important;
    font-weight: 500;
    padding: 6px 12px;
}

.action-cell {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
}

.link-view {
    font-weight: 500;
    color: #1565c0;
    font-size: 0.9rem;
}

.link-view:hover {
    color: #0d47a1;
    text-decoration: underline;
}

.btn-download {
    color: #6c757d;
}

.btn-download:hover {
    color: #495057;
}
</style>
